/**
 * Selección rápida: abre un modal con las variantes del producto.
 * El contenido se pide con la Section Rendering API (section quick-add).
 */
import { theme, fetchSection, openDialog } from '@theme/global';
import '@theme/product';

document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('[data-quick-add-url]');
  if (!trigger) return;
  event.preventDefault();

  const modal = document.getElementById('QuickAdd');
  const content = modal?.querySelector('[data-quick-add-content]');
  if (!modal || !content) {
    window.location.href = trigger.dataset.quickAddUrl;
    return;
  }

  content.replaceChildren();
  content.classList.add('is-loading');
  content.setAttribute('aria-busy', 'true');
  openDialog(modal);

  try {
    const doc = await fetchSection(trigger.dataset.quickAddUrl, 'quick-add');
    const section = doc.querySelector('.shopify-section') || doc.body;
    content.replaceChildren(...section.childNodes);
    content.querySelector('.quick-add__title')?.setAttribute('tabindex', '-1');
    content.querySelector('.quick-add__title')?.focus();
  } catch (err) {
    content.textContent = theme.strings.error;
  } finally {
    content.classList.remove('is-loading');
    content.removeAttribute('aria-busy');
  }
});
